import { render, staticRenderFns } from "./GuideFigure.vue?vue&type=template&id=656f0180&scoped=true"
import script from "./GuideFigure.vue?vue&type=script&lang=js"
export * from "./GuideFigure.vue?vue&type=script&lang=js"
import style0 from "./GuideFigure.vue?vue&type=style&index=0&id=656f0180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f0180",
  null
  
)

export default component.exports